import { Dispatch, SetStateAction, createContext, useContext, useMemo, useState } from "react";

import './DropDownMenuService.scss';
const Context = createContext<IDropDownMenuService>(null)

interface IDropDownMenuService {
    setOpenDropDown: Dispatch<SetStateAction<React.ReactNode>>
    setdropDowns: Dispatch<SetStateAction<Array<React.ReactNode>>>
}
/** 掛鉤於最上層的下拉選單, 可避免被元件包住 */
export function useDropDownMenu() {
    const context = useContext(Context);
    return context;
}
export const DropDownMenuService = ({ children }) => {

    const [open, setOpen] = useState<React.ReactNode>()

    const [dropDowns, setdropDowns] = useState<Array<React.ReactNode>>([])
    const context: IDropDownMenuService = useMemo(() => ({
        // openedDropDown: open,
        setOpenDropDown: setOpen,
        // dropDowns,
        setdropDowns
    }), [])

    return <Context.Provider value={context}>
        {children}
        <div className="x-dropdown-menu-service">
            <div
                className="dropdown-overlay"
                onClick={() => setOpen(undefined)}
            />
            {open && <>{open}</>}
            {dropDowns}
        </div>
    </Context.Provider>
}